(function () {
  if (window._cardVideoInitDone) return;
  window._cardVideoInitDone = true;

  document.addEventListener('click', function (e) {

    //  Open popup
    const badge = e.target.closest('.card-video-badge');
    if (badge) {
      e.preventDefault();
      e.stopPropagation();

      const url = badge.dataset.videoUrl || '';
      const type = badge.dataset.videoType || 'mp4';
      const sku = badge.dataset.sku || '';
      if (!url) {
        console.warn('⚠️ No video URL found for SKU:', sku);
        return;
      }

      const mediaInner = badge.closest('.card-product__media-inner');
      if (!mediaInner) {
        console.warn('⚠️ .card-product__media-inner not found');
        return;
      }



      const popup = mediaInner.querySelector('.card-video-popup') || document.querySelector('.card-video-popup[data-sku="' + sku + '"]');
      if (!popup) {
        console.warn('⚠️ .card-video-popup not found');
        return;
      }
      if (!popup._originalParent) {
        popup._originalParent = mediaInner;
      }

      if (type === 'mp4') {
        const cleanUrl = url.replace(/\+/g, '%20');
        const videoEl = popup.querySelector('video');

        if (!videoEl) {
          console.warn('⚠️ <video> element not found, opening in new tab');
          window.open(cleanUrl, '_blank');
          return;
        }

        videoEl.onerror = null;
        videoEl.onerror = function () {
          console.warn('⚠️ Video failed to load in modal, opening in new tab:', cleanUrl);
          popup.style.display = 'none';
          document.body.style.overflow = '';
          videoEl.onerror = null;
          window.open(cleanUrl, '_blank');
        };

        videoEl.src = cleanUrl;
        videoEl.load();

        document.body.appendChild(popup);
        popup.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        videoEl.play().catch(function (err) {
          console.warn('⚠️ Autoplay blocked or play() failed:', err);
        });
        return;
      }

      // YouTube / Vimeo: open in modal as before
      const iframe = popup.querySelector('iframe');

      if (type === 'youtube') {
        let embedUrl = url;
        if (url.includes('watch?v=')) {
          embedUrl = url.replace('watch?v=', 'embed/').split('&')[0];
        } else if (url.includes('youtu.be/')) {
          const id = url.split('youtu.be/')[1].split('?')[0];
          embedUrl = 'https://www.youtube.com/embed/' + id;
        }
        embedUrl += '?autoplay=1&rel=0';
        if (iframe) iframe.src = embedUrl;

      } else if (type === 'vimeo') {
        const id = url.split('vimeo.com/')[1]?.split('?')[0];
        const embedUrl = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
        if (iframe) iframe.src = embedUrl;
      }

      document.body.appendChild(popup);
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      return;
    }

    // Close
    const closeBtn = e.target.closest('.card-video-close');
    const overlay = e.target.closest('.card-video-overlay');

    if (closeBtn || overlay) {
      const popup = e.target.closest('.card-video-popup');
      if (!popup) return;

      const iframe = popup.querySelector('iframe');
      const videoEl = popup.querySelector('video');

      if (iframe) { iframe.src = ''; }
      if (videoEl) {
        videoEl.pause();
        videoEl.onerror = null;
        videoEl.src = '';
        videoEl.load();
      }

      popup.style.display = 'none';
      document.body.style.overflow = '';
      if (popup._originalParent) {
        popup._originalParent.appendChild(popup);
      }
    }

  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.card-video-popup').forEach(function (popup) {
      if (popup.style.display !== 'none') {
        const iframe = popup.querySelector('iframe');
        const videoEl = popup.querySelector('video');
        if (iframe) { iframe.src = ''; }
        if (videoEl) {
          videoEl.pause();
          videoEl.onerror = null;
          videoEl.src = '';
          videoEl.load();
        }
        popup.style.display = 'none';
        document.body.style.overflow = '';
        if (popup._originalParent) {
          popup._originalParent.appendChild(popup);
        }
      }
    });
  });

})();